import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';

export const BUSCAR_INTERESSADOS_PROMOCAO = '@interessadosPromocaoActions/BUSCAR_INTERESSADOS_PROMOCAO';
export const REMOVER_FILTRO_INTERESSADOS_PROMOCAO = '@interessadosPromocaoActions/REMOVER_FILTRO_INTERESSADOS_PROMOCAO';
export const ADICIONAR_FILTRO_INTERESSADOS_PROMOCAO = '@interessadosPromocaoActions/ADICIONAR_FILTRO_INTERESSADOS_PROMOCAO';
export const LIMPAR_FILTRO_INTERESSADOS_PROMOCAO = '@interessadosPromocaoActions/LIMPAR_FILTRO_INTERESSADOS_PROMOCAO';
export const LISTAR_FILTROS_INTERESSADOS_PROMOCAO = '@interessadosPromocaoActions/LISTAR_FILTROS_INTERESSADOS_PROMOCAO';
export const DETERMINAR_PAGINA_ATUAL_INTERESSADO = '@interessadosPromocaoActions/DETERMINAR_PAGINA_ATUAL_INTERESSADO';
export const ALTERAR_REGISTROS_POR_PAGINA_INTERESSADO = '@interessadosPromocaoActions/ALTERAR_REGISTROS_POR_PAGINA_INTERESSADO';


export function buscarInteressadosPromocao (pagina, registrosPorPagina, filtros) {
  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
  const url = `${URL}/promocoes/recebimento/interessados${urlFiltros}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_INTERESSADOS_PROMOCAO,
        payload: response

      })
  );
}

export function listarFiltros () {
  const url = `${URL}/promocoes/recebimento/filtros`
  return dispatch => axios.get(url).then(
    response => dispatch({
      type: LISTAR_FILTROS_INTERESSADOS_PROMOCAO,
      payload: response
      
    })
  );
}

export function removerFiltro (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_INTERESSADOS_PROMOCAO
  }
}

export function adicionarFiltro (filtro) {
  return {
    type: ADICIONAR_FILTRO_INTERESSADOS_PROMOCAO,
    payload: filtro
  }
}

export  function limparFiltro () {
  return {
    type: LIMPAR_FILTRO_INTERESSADOS_PROMOCAO
  }
}

export function determinarPaginaAtual (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_INTERESSADO,
    payload: paginaAtual
  }
}

export function alterarRegistrosPorPagina (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_INTERESSADO,
    payload: valor
  }
}